var _a;
import { __assign } from "tslib";
import { AVAILABLE_VIDEO_TYPES } from '@wix/wix-vod-shared/dist/src/widget/ui-selectors/video-access';
import { DEFAULT_TRANSLATIONS as VIDEO_PLAY_TRANSLATIONS } from 'shared/components/overlay-texts/play-button-text';
export var DEFAULT_TRANSLATIONS = __assign(__assign({}, VIDEO_PLAY_TRANSLATIONS), (_a = {}, _a[AVAILABLE_VIDEO_TYPES.FULL] = 'widget.overlay-buttons.start-watching', _a));
